import React, { useEffect, useState } from 'react'
import { useLanguage } from '../../../components/context/LanguageContext'
import { Button, Card, Col, Row, Table, Tabs } from 'antd'
import { apiRequest } from '../../../helpers'
import { ReloadOutlined, DownOutlined, UpOutlined } from '@ant-design/icons'

const AgentEmailExecution = ({ agent }) => {
  const [running, setRunning] = useState(false)
  const languageContext = useLanguage()

  const run = async () => {
    setRunning(true)
    try {
      const response = await apiRequest(
        process.env.REACT_APP_API + `agents/emails/${agent.key}/execute`,
        'POST',
        { debug: true }
      )
      const currentDate = new Date().toISOString()
      console.log('[' + currentDate + '] ' + response?.data)
    } catch (error) {
      console.log(error)
    }
    setRunning(false)
  }


  return (
    <>
      <Row>
        <Col sm={12}>
          <Button className="dyn-btn-primary" onClick={run} disabled={running}>
            {languageContext.t(running ? 'Executing' : 'Execute')} {agent.name}{' '}
            {languageContext.t('now')}
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default AgentEmailExecution
